import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { safeMcpReturnUrl } from '../../shared/services/mcp-login-return';
import { UserSettingsService } from '../../shared/services/user-setting.service';

export const mcpSessionGuard: CanActivateFn = (_route, state) => {
  const session = inject(UserSettingsService);
  const router = inject(Router);
  try {
    if (session.validateToken()) return true;
  } catch {
    // Una sesión dañada se recupera con el mismo flujo de inicio de sesión.
  }
  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: safeMcpReturnUrl(state.url) ?? '/mcp/connections' },
  });
};
